import axios from 'axios';

const API_URL = process.env.API_URL;

export async function login(user, isAdmin = false) {
  const url = isAdmin ? `${API_URL}/admin/auth/login` : `${API_URL}/dashboard/auth/login`;
  return axios.post(url, user).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export function logout(accessToken, accessType) {
  const url = `${API_URL}/dashboard/auth/logout`;
  return axios.post(url, null, {
    headers: {
      Authorization: `${accessType} ${accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function register(user) {
  const url = `${API_URL}/dashboard/auth/register`;
  return axios.post(url, user).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function registerArtistWithApplication(formData) {
  const url = `${API_URL}/dashboard/artist-application/register`;
  return axios({
    url,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function forgotPassword(user) {
  const url = `${API_URL}/dashboard/auth/forgot-password`;
  return axios.post(url, user).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function changePassword(user) {
  const url = `${API_URL}/dashboard/auth/change-password`;
  return axios.post(url, user).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDetailUser(authorization) {
  const url = `${API_URL}/dashboard/account/profile`;
  return axios({ url,
    method: 'get',
    headers: { Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function acceptToc(email, authorization) {
  const url = `${API_URL}/dashboard/auth/accept-toc`;
  return axios({
    url,
    method: 'post',
    data: { email },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export const authService = {
  login,
  logout,
  register,
  registerArtistWithApplication,
};



// WEBPACK FOOTER //
// ./src/services/auth.js